var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFitur2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#EFF3FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 32.8579C18.9358 33.8788 17.5 35.3015 17.5 36.875C17.5 39.9816 23.0964 42.5 30 42.5C36.9036 42.5 42.5 39.9816 42.5 36.875C42.5 35.3015 41.0642 33.8788 38.75 32.8579M37.5 25C37.5 30.0796 31.875 32.5 30 36.25C28.125 32.5 22.5 30.0796 22.5 25C22.5 20.8579 25.8579 17.5 30 17.5C34.1421 17.5 37.5 20.8579 37.5 25ZM31.25 25C31.25 25.6904 30.6904 26.25 30 26.25C29.3096 26.25 28.75 25.6904 28.75 25C28.75 24.3096 29.3096 23.75 30 23.75C30.6904 23.75 31.25 24.3096 31.25 25Z",
    stroke: "#3375B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitur2);
export default __webpack_public_path__ + "static/media/fitur2.6d4feb3482bb4201b1cf1afcb4dbbb0a.svg";
export { ForwardRef as ReactComponent };